import { tokenStorage } from '../../api/tokenStorage';
import type {
  IyzicoCompleteRequest,
  IyzicoCompleteResponse,
  IyzicoInitiateRequest,
  IyzicoInitializeResponse,
} from '../../types/payment';
import { loadPendingIyzicoCheckout, clearPendingIyzicoCheckout } from '../../utils/iyzicoPending';
import { mockCreateOrderFromIyzico } from '../orders/ordersService.mock';
import { delay, parseMockToken } from '../mock/storage';

function getMockSessionUserId(): string {
  const userId = parseMockToken(tokenStorage.get() ?? '');
  if (!userId) {
    throw new Error('Oturum gerekli.');
  }
  return userId;
}

export async function mockInitializeIyzico(
  payload: IyzicoInitiateRequest,
): Promise<IyzicoInitializeResponse> {
  await delay(400);

  if (payload.amount <= 0) {
    throw new Error('Ödeme tutarı geçersiz.');
  }

  if (
    !payload.order.consents.preInformationAccepted ||
    !payload.order.consents.distanceSalesAccepted ||
    !payload.order.consents.returnPolicyAccepted
  ) {
    throw new Error('Sipariş için gerekli sözleşme onayları verilmelidir.');
  }

  const token = `mock-iyzico-${crypto.randomUUID()}`;
  const conversationId = `HSL-mock-${Date.now()}`;

  return { token, conversationId };
}

export async function mockCompleteIyzico(
  payload: IyzicoCompleteRequest,
): Promise<IyzicoCompleteResponse> {
  await delay(600);

  const pending = loadPendingIyzicoCheckout(payload.token);
  clearPendingIyzicoCheckout(payload.token);

  const orderPayload = pending?.order ?? payload.order;

  if (
    !orderPayload.consents.preInformationAccepted ||
    !orderPayload.consents.distanceSalesAccepted ||
    !orderPayload.consents.returnPolicyAccepted
  ) {
    throw new Error('Sipariş için gerekli sözleşme onayları verilmelidir.');
  }

  const order = await mockCreateOrderFromIyzico(getMockSessionUserId(), orderPayload);

  return { order, paymentStatus: 'success', paymentReference: payload.conversationId };
}
